import { Box, Button, Typography, Alert } from "@mui/material";
import LoadingSpinner from "../../global/loading-spinner";
import { makeStyles } from "@mui/styles";
import { Delete } from "@material-ui/icons";
import { useState } from "react";
import { useMutation, useQueryClient } from "react-query";
import AxiosT from "../../../setup/setup-axios-bearer";

const useStyles = makeStyles((theme) => ({
  detailItem: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    background: "#F4F4F8",
    borderRadius: "11px",
    marginBottom: "10px",
    padding: "8px",
    "& Button": {
      fontSize: "13px",
      color: "#ABACBE",
      "& svg": {
        fontSize: "16px !important",
      },
    },
  },
}));

const GetTrace = ({
  details,
  isLoading,
  productName,
  factorID,
  productCode,
}) => {
  const classes = useStyles();
  const [action, setAction] = useState("delete-product");
  const queryClient = useQueryClient();

  const { mutate } = useMutation(
    ({ action, id }) =>
      AxiosT.post(`/out-warehouse-with-factor/${factorID}`, {
        action,
        id,
      }),
    {
      onSuccess: (data) => {
        queryClient.resetQueries(["getSaleFactordetail"]);
      },
    }
  );

  const handleDelete = (pdtid) => {
    mutate({
      action,
      id: pdtid,
    });
  };

  return (
    <Box>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <>
          {details.length === 0 ? (
            <Alert severity="info">محصولی یافت نشد</Alert>
          ) : (
            details.map((row, index) => (
              <Box key={index} className={classes.detailItem}>
                <Box>
                  <Typography variant="h3" mb={0.5}>
                    {productName}
                  </Typography>
                  <Typography variant="h3" mb={0.5}>
                    کد محصول : {productCode}
                  </Typography>
                  <Typography variant="h3">بارکد : {row.barcode}</Typography>
                </Box>
                <Button
                  startIcon={<Delete />}
                  onClick={() => handleDelete(row.pdt_id)}
                >
                  حذف
                </Button>
              </Box>
            ))
          )}
        </>
      )}
    </Box>
  );
};
export default GetTrace;
